// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"54b7d5de","9664":"921d19fc"}[chunkId] + ".chunk.css";
};